import React from 'react';
import BreadCurmb from 'components/BreadCrumbMex/BreadCrumb';
import BreadCurmbPasos from 'components/BreadCrumbMex/BreadCrumbTipo2';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import BreadCrumbSegukids from "components/BreadCrumbMex/BreadCrumbSegukids";

export const getBreadCrumb = (ramo) => {
  switch (ramo) {
    case 'AUTO':
      return (
        <div>
          <BreadCurmb {...PASOS_BREADCRUMBS[ramo].breadCrumbPasos[9].breadCrumb} />
          <BreadCurmbPasos {...PASOS_BREADCRUMBS[ramo].breadCrumbPasos[9]} />
        </div>
      );
      break;
    case 'APINDIVIDUAL':
      return (
        <BreadCrumbPasosV2
          {...PASOS_BREADCRUMBS[ramo].breadCrumbPasosCotizacion[4]}
          pasos={PASOS_BREADCRUMBS[ramo]?.pasosCotizacion}
        />
      );
      break;

    case 'lnPresRcpa':
      case 'RCPA':
      return (
        <BreadCrumbPasosV2
          {...PASOS_BREADCRUMBS['lnPresRcpa'].breadCrumbPasosCotizacion[4]}
          styleimg="height200px mr-3"
          pasos={PASOS_BREADCRUMBS['lnPresRcpa']?.pasosCotizacion}
        />
      );
      break;

    case 'lnPresRcp':
      case 'RCP':
      return (
        <BreadCrumbPasosV2
          {...PASOS_BREADCRUMBS['lnPresRcp'].breadCrumbPasosCotizacion[4]}
          styleimg="height200px mr-3"
          pasos={PASOS_BREADCRUMBS['lnPresRcp']?.pasosCotizacion}
        />
      );
      break;

    case 'lnPresCyber':
      case 'CYBER':
      return (
        <div>
          <BreadCurmb {...PASOS_BREADCRUMBS.breadCrumb} showPaths={false} />
          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS['lnPresCyber'].breadCrumbPasosCotizacion[4]}
            styleimg="height200px mr-3"
            pasos={PASOS_BREADCRUMBS['lnPresCyber']?.pasosCotizacion}
          />
        </div>
      );
      break;

    case 'lnPresDO':
      return (
        <div>
          <BreadCurmb {...PASOS_BREADCRUMBS[ramo].breadCrumb} />
          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[ramo].breadCrumbPasosCotizacion[4]}
            styleimg="height200px mr-3"
            pasos={PASOS_BREADCRUMBS[ramo]?.pasosCotizacion}
          />
        </div>
      );
      break;

    case 'MARINEINLAND':
      return (
        <div>
          <BreadCurmb {...PASOS_BREADCRUMBS[ramo].breadCrumb} />
          <BreadCrumbPasosV2 {...PASOS_BREADCRUMBS[ramo].breadCrumbPasos[(1, 2, 3, 4)]} />
        </div>
      );
      break;

    case 'CASUALTYCONTRATISTAS':
      return (
        <div>
          <BreadCurmb {...PASOS_BREADCRUMBS[ramo].breadCrumb} />
          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[ramo].breadCrumbPasosCotizacion[4]}
            styleimg="height200px mr-3"
            pasos={PASOS_BREADCRUMBS[ramo]?.pasosCotizacion}
          />
        </div>
      );
      break;

    case 'CASUALTYGENERALES':
      return (
        <div>
          <BreadCurmb {...PASOS_BREADCRUMBS.breadCrumb} showPaths={false} />
          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[ramo].breadCrumbPasosCotizacion[4]}
            styleimg="height200px mr-3"
            pasos={PASOS_BREADCRUMBS[ramo]?.pasosCotizacion}
          />
        </div>
      );
      break;

    case 'pymesCerradoInd':
      return (
        <div>
          <BreadCurmb {...PASOS_BREADCRUMBS.breadCrumb} showPaths={false} />
          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[ramo].breadCrumbPasosEmision[1]}
            styleimg="height200px mr-3"
            pasos={PASOS_BREADCRUMBS[ramo]?.pasosEmision}
          />
        </div>
      );
      break;

    case 'pymesAbiertoInd':
      return (
        <div>
          <BreadCurmb {...PASOS_BREADCRUMBS[ramo].breadCrumb} showPaths={false} />

          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[ramo].breadCrumbPasosEmision[1]}
            pasos={PASOS_BREADCRUMBS[ramo].pasosEmision}
          />
        </div>
      );
      break;

    case 'hogarCotizadorFlex':
      return (
        <div>
          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS['HOGAR'].breadCrumbPasosCotizacion[3]}
            pasos={PASOS_BREADCRUMBS['HOGAR']?.pasosCotizacion}
          />
        </div>
      );
      break;

    case 'HOGAR':
    case 'hogarCotizadorDTC':
      return (
        <div>
          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS['HOGAR'].breadCrumbPasosCotizacionHogarFlex[4]}
            pasos={PASOS_BREADCRUMBS['HOGAR']?.pasosHogarFlex}
          />
        </div>
      );
      break;

    case 'SKT':
      return (
        <div>
          <BreadCrumbSegukids
            {...PASOS_BREADCRUMBS[ramo].breadCrumbPasosSegukids[6]}
            pasos={PASOS_BREADCRUMBS[ramo]?.pasosContratante}
            showImg={false}
            showImgTitle={true}
            subtitleClassnames={'col-md-12 p-0'}
          />
        </div>
      );
      break;

    default:
      break;
  }
};
